import {openDialog} from 'platform/components';

import {BranchResponseBody} from '@dms/api/shared';
import i18n from '@dms/i18n';

import {RequiredTestIdProps} from 'shared/web';

import {TestDriveCalendarSettingsDialog} from '../components/TestDriveCalendarSettingsDialog';

interface OpenTestDriveCalendarSettingsDialogProps extends RequiredTestIdProps {
  assignedBranches: BranchResponseBody[];
}

export function openTestDriveCalendarSettingsDialog(
  props: OpenTestDriveCalendarSettingsDialogProps
) {
  openDialog(
    <TestDriveCalendarSettingsDialog
      assignedBranches={props.assignedBranches}
      data-testid={props['data-testid']}
    />,
    {
      title: i18n.t('page.testDrive.labels.settingsDialogTitle'),
      size: 'large',
    }
  );
}
